import styled from 'styled-components';

const FilterButtonWrapper = styled.div`
display: flex;
justify-content: center;
text-align: center;

@media only screen and (max-width: 500px) {
    flex-direction: column;
  }
`
export default FilterButtonWrapper;
